module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ga-dec832634c40be902627f39315558653.svg";